var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9299B0CA-60AA-4468-AAC0-C002A0AA9570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-reminders",
    transform: "translate(-871, -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-app-menu",
    transform: "translate(447, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications-icon",
    transform: "translate(424, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,25.3333333 C6.28889333,25.3333333 5.97222667,25.2056 5.71666667,24.95 C5.46110667,24.6944 5.33333333,24.3777333 5.33333333,24 C5.33333333,23.6222667 5.46110667,23.3056 5.71666667,23.05 C5.97222667,22.7944 6.28889333,22.6666667 6.66666667,22.6666667 L8,22.6666667 L8,13.3333333 C8,11.4888933 8.55556,9.85 9.66666667,8.41666667 C10.7777733,6.98333333 12.2222267,6.04444 14,5.6 L14,4.66666667 C14,4.11110667 14.1944,3.63889333 14.5833333,3.25 C14.9722667,2.86110667 15.4444,2.66666667 16,2.66666667 C16.5556,2.66666667 17.0277333,2.86110667 17.4166667,3.25 C17.8056,3.63889333 18,4.11110667 18,4.66666667 L18,5.6 C19.7777333,6.04444 21.2222667,6.98333333 22.3333333,8.41666667 C23.4444,9.85 24,11.4888933 24,13.3333333 L24,22.6666667 L25.3333333,22.6666667 C25.7110667,22.6666667 26.0277333,22.7944 26.2833333,23.05 C26.5389333,23.3056 26.6666667,23.6222667 26.6666667,24 C26.6666667,24.3777333 26.5389333,24.6944 26.2833333,24.95 C26.0277333,25.2056 25.7110667,25.3333333 25.3333333,25.3333333 L6.66666667,25.3333333 Z M16,29.3333333 C15.2666667,29.3333333 14.6389333,29.0722667 14.1166667,28.55 C13.5944,28.0277333 13.3333333,27.4 13.3333333,26.6666667 L18.6666667,26.6666667 C18.6666667,27.4 18.4056,28.0277333 17.8833333,28.55 C17.3610667,29.0722667 16.7333333,29.3333333 16,29.3333333 Z M10.6666667,22.6666667 L21.3333333,22.6666667 L21.3333333,13.3333333 C21.3333333,11.8666667 20.8110667,10.6111067 19.7666667,9.56666667 C18.7222667,8.52222667 17.4666667,8 16,8 C14.5333333,8 13.2777733,8.52222667 12.2333333,9.56666667 C11.1888933,10.6111067 10.6666667,11.8666667 10.6666667,13.3333333 L10.6666667,22.6666667 Z",
    id: "Shape",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIconActive);
export default __webpack_public_path__ + "static/media/notifications-icon-active.638f646b7f0e05afd457ba1346a0b54a.svg";
export { ForwardRef as ReactComponent };